<div class="op-standard-layout">
  <global-top-nav id="global-top-nav-slot"></global-top-nav>
  <global-side-nav id="global-side-nav-slot">
    <!-- Only render the sub-nav when there's actually something to show; otherwise the empty bar
         (and its margin) would add space above the page content / control panel. -->
    @if (visibleSubNavConfig$ | async; as subNavConfig) {
      <nv-sub-nav
        main
        class="op-standard-layout__sub-nav"
        [navigationTabs$]="navigationTabs$"
        [showSubNav$]="showSubNav$"
        [showWarningMessage]="subNavConfig.showWarningMessage"
        [warningMessage]="subNavConfig.warningMessage"
        [warningTooltip]="subNavConfig.warningTooltip"
        [nvNotePriority]="subNavConfig.nvNotePriority || 'warning'"
        [filterConfigs]="subNavConfig.filterConfigs"
        [actionButton]="subNavConfig.actionButton"
        (actionButtonClicked)="onActionButtonClicked()"
        [origin]="origin"
        [portal]="portal"
        [slideToggle]="subNavConfig?.slideToggle"
        (slideToggleChanged)="onSlideToggleChanged($event)"
        [segmentedControl]="subNavConfig.segmentedControl"
        (segmentedControlChanged)="onSegmentedControlChanged($event)"
        [hasLink]="subNavConfig.hasLink"
        [href]="subNavConfig.href"
        [linkText]="subNavConfig.linkText">
      </nv-sub-nav>
    }
    <router-outlet main></router-outlet>
  </global-side-nav>
</div>
